import {StepNumber} from '@codev/helix-react';
import PropTypes from 'prop-types';
import React from 'react';
import translations from './translations.js';

const Step2 = ({
  language = 'en_US',
  secretKey,
}) => (
  <StepNumber number={2}>
    {translations('step2Text0', language)}
    {translations('step2Text1', language)}
    <div style={{marginLeft: '139px', marginBottom: '5px', marginTop: '5px'}}>
      {translations('step2Text2', language)}
    </div>
    <div style={{marginBottom: '10px'}}>
      {translations('step2Text3', language)}
    </div>
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        marginLeft: '25px',
        marginTop: '15px'
      }}
    >
      <span style={{marginRight: '10px'}}>
        <strong>{translations('step2Key', language)}</strong>
      </span>
      <span style={{width: '375px', overflowWrap: 'break-word'}}>{secretKey}</span>
    </div>
  </StepNumber>
);

Step2.propTypes = {
  secretKey: PropTypes.string.isRequired,
};

export default Step2;